import React from 'react';
import { components } from 'react-select';

import { ReactComponent as CheckCheckRound } from '../../../../assets/images/icon-check-circle.svg';
import { ReactComponent as CheckRound } from '../../../../assets/images/icon-circle.svg';

import styles from './SelectCustomOption.module.scss';

export const SelectCustomOption = ({ children, ...restProps }) => (
  <components.Option {...restProps}>
    <div
      role="option"
      aria-selected={restProps.isSelected ? 'true' : 'false'}
      className={styles.customOptionContainer}
      tabIndex={0}
    >
      <div>{children}</div>
      {restProps.isSelected ? <CheckCheckRound /> : <CheckRound />}
    </div>
  </components.Option>
);
